import { Box, Chip, Typography } from "@mui/material";
import { Schedule as ScheduleIcon } from "@mui/icons-material";
import { ReservationInfo } from "./listTypes";
import { formatTime, getShortWeekDayLabel } from "./listHelpers";

type ReservationRowProps = {
    label: string;
    reservations: Array<ReservationInfo>;
    color: "primary" | "warning";
};

export const ReservationRow = ({ label, reservations, color }: ReservationRowProps) => {
    const validReservations = reservations.filter((r) => r.time && r.time.trim() !== "");
    const sortedReservations = [...validReservations].sort((a, b) => a.weekDay - b.weekDay);

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 }}>
            <Typography variant="caption" sx={{ fontSize: "0.75rem", fontWeight: "bold", flexShrink: 0 }}>
                {label}:
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    gap: 0.5,
                    overflowX: "auto",
                    maxWidth: 210,
                    "&::-webkit-scrollbar": { height: 4 },
                    "&::-webkit-scrollbar-thumb": { backgroundColor: "#ccc", borderRadius: 2 },
                }}
            >
                {sortedReservations.length > 0 ? (
                    sortedReservations.map((reservation, index) => (
                        <Chip
                            key={`${reservation.weekDay}_${reservation.time}_${index}`}
                            icon={<ScheduleIcon sx={{ fontSize: "12px !important" }} />}
                            label={`${getShortWeekDayLabel(reservation.weekDay)} ${formatTime(reservation.time)}`}
                            size="small"
                            variant="outlined"
                            color={color}
                            sx={{ fontSize: "0.7rem", height: "20px", flexShrink: 0 }}
                        />
                    ))
                ) : (
                    <Typography variant="caption" color="text.disabled" sx={{ fontSize: "0.75rem" }}>
                        N/A
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

